import KeywordListItem from './KeywordListItem.vue';

export default KeywordListItem;
